document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("marquee-track");
  const container = document.getElementById("marquee-container");

  let direction = -1; // -1 = left, 1 = right
  let position = 0;
  let speed = 60; // px/sec

  // Duplicate slides for infinite effect
  track.innerHTML += track.innerHTML;

  const trackWidth = track.scrollWidth / 2;

  // Force GPU acceleration
  track.style.willChange = "transform";
  track.style.transform = `translate3d(0,0,0)`; // initial placement

  function animate(lastTime) {
    return function frame(time) {
      if (!lastTime) lastTime = time;
      const delta = (time - lastTime) / 1000;
      lastTime = time;

      position += direction * speed * delta;

      if (direction === -1) {
        if (position <= -trackWidth) position += trackWidth;
      } else {
        if (position >= 0) position -= trackWidth;
      }

      track.style.transform = `translate3d(${position}px, 0, 0)`;
      requestAnimationFrame(frame);
    };
  }

  // Delay animation start until next paint (avoids flicker)
  requestAnimationFrame(() => {
    requestAnimationFrame(animate());
  });

  // Drag to change direction
  let startX = null;
  container.addEventListener("mousedown", (e) => (startX = e.clientX));
  container.addEventListener("mouseup", (e) => {
    if (startX !== null) {
      const deltaX = e.clientX - startX;
      direction = deltaX < 0 ? -1 : 1;
      startX = null;
    }
  });
});
